import React from "react";
import BaseButton from "./BaseButton";


const BaseCreate = (props) => <BaseButton className="cancelBtn" type="primary" danger { ...props }>{ props.text ? props.text : "Close" }</BaseButton>

export default BaseCreate;
